import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import StudioDashboard from "./Studio/StudioDashboard";
import FamilyTreeStudioPage from "./Studio/FamilyTreeStudioPage";
import MissionaryStudioPage from "./Studio/MissionaryStudioPage";
import OrderDetailsStudio from "./Studio/OrderDetailsStudio";
import MediaManagerStudio from "./Studio/MediaManagerStudio";
import AccountSettingsTab from "./AccountSettingsTab";
import { Box, Button, Container } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import GenerationalStudioPage from "./Studio/GenerationalStudioPage";

const SettingsPageWrapper = () => (
  <Box sx={{ p: 4 }}>
    <Container>
      <Button startIcon={<ArrowBack />} href="/account" sx={{ mb: 2 }}>Back to Studio</Button>
      <AccountSettingsTab />
    </Container>
  </Box>
);

const AccountPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<StudioDashboard />} />
      <Route path="tree" element={<FamilyTreeStudioPage />} />
      <Route path="mission" element={<MissionaryStudioPage />} />
      <Route path="generational" element={<GenerationalStudioPage />} />
      <Route path="orders/:orderId" element={<OrderDetailsStudio />} />
      <Route path="media" element={<MediaManagerStudio />} />
      <Route path="settings" element={<SettingsPageWrapper />} />
      <Route path="*" element={<Navigate to="/account" />} />
    </Routes>
  );
};

export default AccountPage;

